import { Tab, Text } from "@chakra-ui/react";

const CustomTab = ({ children, ...props }) => {
  return (
    <Tab
      bg="none"
      pos="relative"
      top="0"
      w="263px"
      // minW='-webkit-fit-content'
      maxW="283px"
      display="flex"
      alignItems="baseline"
      float="none"
      h="32px"
      p="0 8px"
      lineHeight="18.78px"
      borderBottom="1px solid #CCCFD1"
      overflowY="visible"
      color="#5C6066"
      _selected={{
        color: "#292B30",
        fontWeight: 600,
        border: "none",
      }}
      userSelect="none"
      zIndex={1}
      transition="margin-top 0.2s, height 0.2s"
      className="tab-rounded-border"
      {...props}
    >
      <Text
        as="span"
        whiteSpace="nowrap"
        overflow="hidden"
        textOverflow="ellipsis"
      >
        {children}
      </Text>
    </Tab>
  );
};

export default CustomTab;
